document.addEventListener('DOMContentLoaded', () => {
  const SECTIONS = document.querySelectorAll('.mtt-text-widget')
  if (SECTIONS.length > 0) {
    SECTIONS.forEach(SECTION => {
      const textWidget = new TextWidget(SECTION)
      textWidget.init()
    })
  }
})

class TextWidget {
  constructor (WRAPPER) {
    this.WRAPPER = WRAPPER
    this.SECTIONS = this.WRAPPER.querySelectorAll('.mtt-text-widget__section')

    this.sectionLinkArr = []

    this.ticking = false
  }

  init () {
    if (!this.SECTIONS) return

    this.buildSectionLinkArr()
    this.handleScroll()
    this.handleClick()
  }

  buildSectionLinkArr () {
    this.SECTIONS.forEach(SECTION => {
      const sectionId = SECTION.dataset.sectionIndex
      const matchingLinkElement = this.WRAPPER.querySelector(`.mtt-text-widget__list-item[data-index="${sectionId}"]`)
      this.sectionLinkArr.push({
        section: SECTION,
        linkElement: matchingLinkElement
      })
    })
  }

  handleScroll () {
    document.addEventListener('scroll', () => {
      if (this.getScreenWidth() <= 850) return
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.scrollEvent()
          this.ticking = false
        })
        this.ticking = true
      }
    })
  }

  scrollEvent () {
    if (!this.sectionLinkArr) return

    this.sectionLinkArr.forEach(SECTION => {
      const { section, linkElement } = SECTION

      const boundingClient = section.getBoundingClientRect()
      const headerHeight = this.getHeaderHeight() + 5
      const atTop = boundingClient.top <= headerHeight
      const bottomAtTop = boundingClient.bottom >= headerHeight

      atTop && bottomAtTop ?
        linkElement.classList.add('mtt-text-widget__list-item--active'):
        linkElement.classList.remove('mtt-text-widget__list-item--active')
    })
  }

  handleClick () {
    if (!this.sectionLinkArr) return

    this.sectionLinkArr.forEach(SECTION => {
      const { section, linkElement } = SECTION

      linkElement.addEventListener('click', () => {
        jQuery('html, body').animate({
          scrollTop: jQuery(section).offset().top - this.getHeaderHeight()
        }, 800)
      })
    })
  }

  getHeaderHeight () {
    let height = this.getScreenWidth() <= 1160 ? 64 : 96
    if (document.getElementById('wpadminbar')) {
      height += 32
    }
    return height
  }

  getScreenWidth () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  }
}

